/* @flow weak */
import BoxBody from 'components/BoxBody.jsx';
import cx from 'classnames';
import Dialog from 'components/Dialog.jsx';
import PaymentSourceForm from './PaymentSourceForm.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';

const AddPaymentSourceModal = React.createClass({
  propTypes: {
    onPaymentSourceAdded: React.PropTypes.func,
  },

  onPaymentSourceAdded(paymentSource) {
    this.props.onRequestHide();
    ToastActions.showSuccessToast('Card created');
    if (this.props.onPaymentSourceAdded) {
      this.props.onPaymentSourceAdded(paymentSource);
    }
  },

  render() {
    const { className, ...rest } = this.props;

    return (
      <Dialog
        eventScreenName="AddPaymentSourceModal"
        {...rest}
        size="medium"
        className={cx('AddPaymentSourceModal', className)}>
        <BoxBody>
          <TitleHeader title="Add a credit or debit card" />
          <PaymentSourceForm onCreated={this.onPaymentSourceAdded} />
        </BoxBody>
      </Dialog>
    );
  },
});

export default AddPaymentSourceModal;



// WEBPACK FOOTER //
// ./src/payments/components/AddPaymentSourceModal.jsx